// ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserContext } from './UserContext';
import {validAuthReturn} from '../shared/authContinuation';
import {authDestination} from './client/authContinuation';

const ProtectedRoute = ({ children, adminOnly = false, allowAnonymous = false }) => {
  const token = localStorage.getItem('token');
  const { userDetails, loading } = useContext(UserContext);
  const location = useLocation();

  // Redirect to login if no token is found
  if (!token) {
    if (allowAnonymous) return children;
    return <Navigate to={authDestination('/login', validAuthReturn(location.pathname + location.search))} replace />;
  }

  // Wait for user details to load before checking admin status
  if (loading) {
    return null; // Or a loading spinner
  }
  if (userDetails?.onboarding_pending) {
    return <Navigate to={authDestination('/authorization', validAuthReturn(location.pathname + location.search) || userDetails.signup_return_to)} replace />;
  }

  // If adminOnly is true, check if the user has admin rights
  if (adminOnly && !userDetails?.is_admin) {
    return <Navigate to="/unauthorized" replace />; // Redirect if not admin
  }

  return children;
};

export default ProtectedRoute;
